import React, { FC, Suspense } from "react";
import FlowioRoute from "src/components/atoms/Route";
import { AppLayoutProps } from "../types";
import DashboardLayout from "./DashboardLayout";
import Loader from "../../../atoms/Loader";

const DashboardLayoutRoute: FC<AppLayoutProps> = ({
  component: Component,
  render: renderFunc,
  ...rest
}) => (
  <FlowioRoute
    {...rest}
    render={(matchProps) => (
      <DashboardLayout>
        <Suspense fallback={<Loader />}>
          {Component !== undefined && <Component {...matchProps} />}
          {renderFunc !== undefined && renderFunc(matchProps)}
        </Suspense>
      </DashboardLayout>
    )}
  />
);

export default DashboardLayoutRoute;
